export const getNamespaceForChainId = (chainId: string) => {
  const chain = chains.find((c) => c.id === chainId);
  return chain?.namespace;
};

export const chains = [
  {
    id: '1',
    namespace: 'eip155',
    name: 'Ethereum Mainnet',
    label: 'ETH',
    explorer: 'etherscan.io',
  },
  {
    id: '56',
    namespace: 'eip155',
    name: 'Binance Smart Chain',
    label: 'BSC',
    explorer: 'bscscan.com',
  },
  {
    id: '100',
    namespace: 'eip155',
    name: 'Gnosis Chain',
    label: 'Gnosis',
    explorer: 'gnosisscan.io',
  },
  {
    id: '137',
    namespace: 'eip155',
    name: 'Polygon',
    label: 'MATIC',
    explorer: 'polygonscan.com',
  },
  {
    deprecated: true,
    id: '4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ',
    namespace: 'solana',
    name: 'Solana',
    label: 'SOL',
    explorer: 'solscan.io',
  },
  {
    id: '5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp',
    namespace: 'solana',
    name: 'Solana',
    label: 'SOL',
    explorer: 'solscan.io',
  },
  {
    id: '42161',
    namespace: 'eip155',
    name: 'Arbitrum One',
    label: 'ARB',
    explorer: 'arbiscan.io',
  },
  {
    id: '534352',
    namespace: 'eip155',
    name: 'Scroll',
    label: 'Scroll',
    explorer: 'scrollscan.com',
  },
  {
    id: '10',
    namespace: 'eip155',
    name: 'Optimism',
    label: 'OP',
    explorer: 'optimistic.etherscan.io',
  },
  {
    id: '43114',
    namespace: 'eip155',
    name: 'Avalanche C-Chain',
    label: 'AVAX',
    explorer: 'snowscan.xyz',
  },
  {
    id: '42220',
    namespace: 'eip155',
    name: 'Celo Mainnet',
    label: 'CELO',
    explorer: 'celoscan.io',
  },
  {
    id: '8453',
    namespace: 'eip155',
    name: 'Base Mainnet',
    label: 'Base',
    explorer: 'basescan.org',
  },
  {
    id: '250',
    namespace: 'eip155',
    name: 'Fantom Opera',
    label: 'FTM',
    explorer: 'explorer.fantom.network',
  },
  {
    id: '324',
    namespace: 'eip155',
    name: 'zkSync',
    label: 'zkSync',
    explorer: 'era.zksync.network',
  },
  {
    id: '000000000019d6689c085ae165831e93',
    namespace: 'bip122',
    name: 'Bitcoin',
    label: 'BTC',
    explorer: 'mempool.space'
  },
  {
    id: '1284',
    namespace: 'eip155',
    name: 'Moonbeam',
    label: 'GLMR',
    explorer: 'moonscan.io',
  },
  {
    id: '59144',
    namespace: 'eip155',
    name: 'Linea',
    label: 'LINEA',
    explorer: 'lineascan.build',
  },
  {
    id: '1285',
    namespace: 'eip155',
    name: 'Moonriver',
    label: 'MOVR',
    explorer: 'moonriver.moonscan.io',
  },
  {
    id: '25',
    namespace: 'eip155',
    name: 'Cronos Mainnet',
    label: 'CRO',
    explorer: 'cronoscan.com',
  },
  {
    id: '199',
    namespace: 'eip155',
    name: 'BitTorrent Chain Mainnet',
    label: 'BTT',
    explorer: 'bttcscan.com',
  },
  {
    id: '1101',
    namespace: 'eip155',
    name: 'Polygon zkEVM',
    label: 'zkEVM',
    explorer: 'zkevm.polygonscan.com',
  },
  {
    id: '1111',
    namespace: 'eip155',
    name: 'WEMIX3.0 Mainnet',
    label: 'WEMIX',
    explorer: 'wemixscan.com',
  },
  {
    id: '146',
    namespace: 'eip155',
    name: 'Sonic',
    label: 'SONIC',
    explorer: 'sonicscan.org',
  },
  {
    id: "81457",
    namespace: "eip155",
    name: "Blast",
    label: "BLAST",
    explorer: "blastscan.io"
  }
]